import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=79c7abb1&scoped=true&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTile.vue?vue&type=style&index=0&id=79c7abb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c7abb1",
  null
  
)

export default component.exports